import React, { useState, useEffect, useRef } from 'react';
import './EnrolNow.css';
import './BookTrail.css';
import { areas } from '../Centers/areas';
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import locationIcon from '../Image/location.png';

const termsData = {
  title: "Machaxi Swimming Playing Trial - Terms & Conditions",
  sections: [
    {
      heading: "1. Trial Fee",
      content: "Swimming playing trials are chargeable. The applicable fee will be shown at the time of booking."
    },
    {
      heading: "2. Adjustment of Trial Fee",
      content: "The trial fee will be adjusted when the user purchases a Swimming Playing Membership (applicable once per user)."
    },
    {
      heading: "3. One Trial per Person",
      content: "Each individual is entitled to only one trial per sport. Duplicate bookings using multiple phone numbers or accounts may be declined."
    },
    {
      heading: "4. Booking Confirmation",
      content: "Trial slot is confirmed only after successful payment."
    },
    {
      heading: "5. Non-Refundable",
      content: "Trial fee is non-refundable, including in case of cancellation or no-show."
    },
    {
      heading: "6. Slot-Based Access",
      content: "Trial is valid only for the selected date and time slot."
    },
    {
      heading: "7. Rescheduling",
      content: "One-time rescheduling is permitted, subject to slot availability."
    },
    {
      heading: "8. Gear & Attire Requirements",
      content: "Users must arrive in proper swimwear and follow all pool safety and hygiene guidelines as per centre rules."
    },
    {
      heading: "9. Facility Usage Rules",
      content: "All instructions from centre staff must be followed during the session."
    },
    {
      heading: "10. Limited Access",
      content: "Trial access does not guarantee future slot availability under membership plans."
    }
  ]
};

const BookTrial = () => {
  const [userName, setUserName] = useState('');
  const [selectedCourtId, setSelectedCourtId] = useState([]);
  const [selectedCourtTimingId, setSelectedCourtTimingId] = useState([]);
  const [isCreatingNewChild, setIsCreatingNewChild] = useState(false);
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [showCreateChildInput, setShowCreateChildInput] = useState(false);
  const [newChildName, setNewChildName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [showAreaDropdown, setShowAreaDropdown] = useState(false);
  const [trialTimes, setTrialTimes] = useState([]);
  const [showCenterDropdown, setShowCenterDropdown] = useState(false);
  const [showChildDropdown, setShowChildDropdown] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const selectWrapperRef = useRef(null);
  const childDropdownRef = useRef(null);
  const [centers, setCenters] = useState([]);
  const navigate = useNavigate();
  const [selectedTrialDate, setSelectedTrialDate] = useState('');
  const [selectedTrialTime, setSelectedTrialTime] = useState('');
  const [trialDates, setTrialDates] = useState([]);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(true);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const [errorMessages, setErrorMessages] = useState({
    userName: '',
    contactNumber: '',
    selectedCenter: '',
    selectedTrialTime: '',
    otp: '',
    child: '',
    userCategory: '',
    termsAccepted: '',
  });

  const [userDetails, setUserDetails] = useState(null);
  const [parentId, setParentId] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [userCategory, setUserCategory] = useState('Adult'); // Default to Adult
  const [proficiencyLevel, setProficiencyLevel] = useState('Basic'); // Default to Basic
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [locationLoading, setLocationLoading] = useState(false);
  const [slotAmount, setSlotAmount] = useState(null);

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };

  const getLocationName = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
      );

      if (response.data.results && response.data.results.length > 0) {
        const formattedAddress = response.data.results[0].formatted_address;
        setSearchValue(formattedAddress);
      }

      const sorted = centers
        .map(center => ({
          ...center,
          distance: calculateDistance(latitude, longitude, center.latitude, center.longitude)
        }))
        .sort((a, b) => a.distance - b.distance);

      setCenters(sorted);
    } catch (err) {
      console.error("Geocoding error:", err);
      Swal.fire('Error', 'Failed to fetch your address.', 'error');
    }
  };

  const updateLocation = async () => {
    if (!navigator.geolocation) {
      Swal.fire('Error', 'Geolocation is not supported.', 'error');
      return;
    }

    setLocationLoading(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        getLocationName(latitude, longitude);
        setLocationLoading(false);
      },
      (error) => {
        setLocationLoading(false);

        let msg = 'Location access denied.';
        if (error.code === 1) msg = 'Please enable location permissions in your Browser and System Settings.';
        if (error.code === 2) msg = 'Location unavailable. Try searching manually.';
        if (error.code === 3) msg = 'Location request timed out.';

        Swal.fire('Location Error', msg, 'error');
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      }
    );
  };

  const handleLocationSearch = (place) => {
    if (place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setSearchValue(place.formatted_address);

      const sorted = centers
        .map(center => ({
          ...center,
          distance: calculateDistance(lat, lng, center.latitude, center.longitude)
        }))
        .sort((a, b) => a.distance - b.distance);

      setCenters(sorted);
    }
  };

  const handleCenterSelect = (center) => {
    setSelectedCenter(center);
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedCenter: '',
      selectedTrialDate: '',
      selectedTrialTime: ''
    }));
    setSlotAmount(null);
  };

  const handleCategoryChange = (category) => {
    setUserCategory(category);
    setErrorMessages((prevErrors) => ({ ...prevErrors, userCategory: '' })); // Clear error
  };

  useEffect(() => {
    // Reset selected date and time slot when category changes
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]); // Clear available slots
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
      selectedTrialTime: '',
    }));
    setSlotAmount(null);
  }, [userCategory]);


  useEffect(() => {
    if (contactNumber) {
      setIsOtpVerified(false);
      setOtp('');
      setUserName('');
      setUserDetails(null);
      setShowOtpInput(false);
      setIsNewUser(false);
      setErrorMessages({
        userName: '',
        contactNumber: '',
        selectedArea: '',
        selectedCenter: '',
        selectedTrialTime: '',
        otp: '',
        child: '',
        userCategory: '',
        termsAccepted: '',
      });
    }
  }, [contactNumber]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (childDropdownRef.current && !childDropdownRef.current.contains(event.target)) {
        setShowChildDropdown(false);
        setShowCreateChildInput(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const fetchSportsCenters = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL_CENTER, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        }
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch sports centers.');
      }

      const defaultImages = [
        "https://imgmediagumlet.lbb.in/media/2022/01/61efa39514a08c2400a7ce56_1643094933277.png",
        "https://i.ytimg.com/vi/K8RGq4xtJbg/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAnvqqpSN_Z3Gha4COeOk9un1cj8Q",
        "https://www.scai.in/wp-content/uploads/2023/06/DSC2954-scaled.jpg"
      ];

      const academyImages = data.academyImages || {};
      const centersData = Object.values(data.sportsToAcademiesMap.Swimming).flat();
      setCenters(
        centersData.filter(center => center.id !== 86).map(center => {
          const academyId = center?.id;
          const areaCenter = areas.flatMap(area => area.centers).find(ac => ac.id === academyId);

          return {
            id: center.id,
            name: center.name,
            latitude: Number(center.latitude) || 0,
            longitude: Number(center.longitude) || 0,
            address: center.address || '',
            images: academyImages[academyId] || defaultImages,
            mapUrl: areaCenter ? areaCenter.location : '#',
          };
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      showBackendError(error);
    }
  };

  useEffect(() => {
    if (centers.length > 0) {
      updateLocation();
    }
  }, [centers.length]);

  useEffect(() => {
    fetchSportsCenters();
  }, []);


  useEffect(() => {

  }, [selectedChildId]);


  const fetchUserDetails = async (mobileNumber) => {
    try {
      const formattedMobileNumber = mobileNumber.startsWith('+91') ? mobileNumber : '+91' + mobileNumber;
      const response = await fetch(process.env.REACT_APP_API_URL_FETCH_USER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({ mobileNumber: formattedMobileNumber }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch user details.');
      }
      if (data && data.userDetails.success) {
        setUserDetails(data.userDetails);
        setIsNewUser(false);
        const parentId = data.userDetails.parent.id;
        const parentName = data.userDetails.parent.name;
        setParentId(parentId);
        setUserName(parentName);
      } else {
        setUserDetails(null);
        setIsNewUser(true);
        setParentId(null);
      }
    } catch (error) {
      setIsNewUser(true);
      setParentId(null);
      console.error("Error fetching user details:", error);
    }
  };

  const handleOptionSelect = (id) => {
    setSelectedCenter(id);
    setShowCenterDropdown(false);
  };
  const handleChildSelect = (child) => {

    if (child.isParent) {

      setUserName(child.name); // Set parent name
      setSelectedChildId(null); // No child ID for parent
      setIsCreatingNewChild(false); // Not creating a new child
    } else {

      setUserName(child.name); // Set child name
      setSelectedChildId(child.id); // Set child ID
      setIsCreatingNewChild(false);
    }
    setErrorMessages((prevErrors) => ({ ...prevErrors, child: '' })); // Clear child error
    setShowChildDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    let errors = {
      userName: !userName.trim() ? 'Name is required' : '',
      contactNumber: !contactNumber.trim() || !isContactNumberValid ? 'Please enter a valid contact number' : '',
      selectedCenter: !selectedCenter ? 'Please select a center' : '',
      selectedTrialDate: !selectedTrialDate ? 'Please select a date' : '',
      selectedTrialTime: !selectedTrialTime ? 'Please select a trial time' : '',
      otp: !isOtpVerified ? 'Please verify OTP before submitting' : '',
      child: !userName.trim() ? 'Please select or create a child' : '',
      userCategory: !userCategory.trim() ? 'Please select a Category' : '', // Validate userCategory
      termsAccepted: !isTermsAccepted ? 'Please accept the Terms & Conditions' : '',
    };

    const hasErrors = Object.values(errors).some((error) => error !== '');

    if (hasErrors) {
      setErrorMessages(errors);
      return;
    }

    const slotsData = await fetchAvailableSlots();
    const isReschedule = slotsData?.isReschedule || false;
    const isRescheduleLimitError = slotsData?.isRescheduleLimitError || false;
    if (isRescheduleLimitError) return;
    try {
      const bookingData = {
        userName,
        contactNumber,
        selectedCenter,
        selectedTrialDate: formatDate(selectedTrialDate), // Format the date
        selectedTrialTime,
        selectedChildId,
        amount: isReschedule ? 0 : slotAmount,
        isReschedule
      };

      setFormData(bookingData);
      setShowConfirmationModal(true);
    } catch (error) {
      console.error('Error during form submission:', error);
      setErrorMessages({ api: 'Failed to process the booking' });
      showBackendError(error);
    }
  };

  const handleOtpVerification = async () => {
    try {
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_VERIFY, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
          otp: otp,
        },
      });

      if (response.data.success) {
        setIsOtpVerified(true);

      } else {
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          otp: response.data.message || 'Invalid OTP, please try again',
        }));
        Swal.fire({
          icon: 'error',
          title: 'Invalid OTP',
          text: response.data.message || 'The OTP you entered is invalid. Please try again.',
        });
      }
    } catch (error) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        otp: 'Failed to verify OTP. Please try again.',
      }));
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to verify OTP. Please try again.',
      });
    }
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setErrorMessages((prevErrors) => ({ ...prevErrors, [field]: '' }));

    if (field === 'userName') {
      setUserName(value);
    } else if (field === 'contactNumber') {
      setContactNumber(value);
    } else if (field === 'otp') {
      setOtp(value);
    }
  };
  const handleSendOtpClick = async () => {
    const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;

    try {
      setIsOtpLoading(true);

      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_SEND, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
        },
      });

      if (response.data.success) {
        setShowOtpInput(true);
        setIsOtpVerified(false);
        setOtp('');
        setIsOtpSent(true);

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `OTP sent to ${formattedContactNumber} via WhatsApp and SMS. Please enter it to proceed.`,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        await fetchUserDetails(contactNumber);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed to Send OTP',
          text: response.data.message || 'Something went wrong. Please try again.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to send OTP. Please try again.',
      });
    } finally {
      setIsOtpLoading(false);
    }
  };


  function formatDate(date) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$02-$01-$03');
  }
  const calculateDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDifference = end - start;
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return Math.abs(Math.floor(daysDifference));
  };



  const handleTrialTimeChange = (time, batchId, status, courtId) => {
    if (status === 'Available') {
      setSelectedTrialTime(time);
      setSelectedCourtId(courtId);
      setErrorMessages((prevErrors) => ({ ...prevErrors, selectedTrialTime: '' }));
    }
  };

  const selectedAreaCenter = selectedCenter
    ? areas
      .flatMap(area => area.centers)
      .find(center => center.id === selectedCenter.id)
    : null;

  const excludedTrialDates = (selectedAreaCenter?.excludeDates || []).map((date) => {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(year, month - 1, day);
  });

  const isContactNumberValid = /^[0-9]{10}$/.test(contactNumber);
  const ConfirmationModal = ({ showModal, onClose, onConfirm, bookingData, selectedCourtId, selectedCourtTimingId }) => {
    if (!showModal) return null;

    const handleConfirm = async () => {
      try {
        let parentIdToSend = null;
        let childIdToSend = null;

        if (newChildName) {
          // If a new child is being added, set parent ID to the parent's ID and child ID to null
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = null;
        } else if (selectedChildId) {
          // If a specific child is selected, set parent ID to the parent's ID and child ID to the selected child's ID
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = selectedChildId;
        } else if (userDetails && !selectedChildId) {
          // If no child is selected and userDetails is present, assume the parent is selecting itself
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = userDetails?.parent?.id || null; // Set child ID to parent ID
        } else {
          // Default case, set both IDs to null
          parentIdToSend = null;
          childIdToSend = null;
        }

        // Find the selected center's academy_id
        const academyIdToSend = bookingData.selectedCenter?.id || null;

        // Format mobile number
        const formattedMobileNumber = bookingData.contactNumber.startsWith('+91')
          ? bookingData.contactNumber
          : '+91' + bookingData.contactNumber;
        const formattedProficiencyLevel = proficiencyLevel.toUpperCase();

        // Check if amount is 0, then call reschedule-trial2 API directly
        if (bookingData.amount === 0 && bookingData.isReschedule) {
          const reschedulePayload = {
            isPlayingTrial: 1,
            isCoachingTrial: 0,
            user_id: childIdToSend || parentIdToSend,
            name: bookingData.userName,
            email: null,
            mobile_number: formattedMobileNumber,
            gender_type: "female", // Default to female, can be made dynamic
            // sport_id: 97,
            sport_id: 11,
            academy_id_new: academyIdToSend,
            academy_id_prev: academyIdToSend,
            court_id: selectedCourtId,
            start_time: bookingData.selectedTrialTime.split(" - ")[0],
            end_time: bookingData.selectedTrialTime.split(" - ")[1],
            booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
            area: null,
            source: "Swimming_Playing"
          };

          const rescheduleResponse = await axios.post(
            'https://admin.machaxi.com/summer-api/trial/reschedule-trial2',
            reschedulePayload,
            {
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': 'jNtunfkUwiAT4YXgQacG84SXO0ZRrzCxSnyUaFunqg',
              }
            }
          );

          console.log("DEBUG - rescheduleResponse", rescheduleResponse);
          const rescheduleSuccess = typeof (rescheduleResponse?.data?.message) === "string" && rescheduleResponse?.data?.message === "Trial rescheduled Successfully";
          if (rescheduleSuccess) {
            Swal.fire({
              icon: 'success',
              title: 'Booking Confirmed!',
              text: 'Your trial has been resheduled successfully.',
              confirmButtonColor: '#322978'
            }).then(() => {
              window.location.href = '/SuccessPage';
              sessionStorage.setItem('paymentStatus', 'success');
              sessionStorage.setItem('message', 'Your trial has been successfully booked.');
              onClose();
              setContactNumber('');
              setIsOtpVerified(false);
              setOtp('');
              setShowOtpInput(false);
            });
          } else {
            throw new Error(rescheduleResponse.data.message || 'Failed to confirm booking.');
          }
          return;
        }

        // Zero-amount new booking path
        if (bookingData.amount === 0 && !bookingData.isReschedule) {
          const createTrialPayload = {
            parent_id: parentIdToSend,
            user_id: childIdToSend ?? parentIdToSend,
            name: bookingData.userName,
            mobile_number: formattedMobileNumber,
            gender_type: "Male",
            academy_id: academyIdToSend,
            court_id: selectedCourtId,
            sport_id: 11,
            // sport_id: 97,
            start_time: bookingData.selectedTrialTime.split(" - ")[0],
            end_time: bookingData.selectedTrialTime.split(" - ")[1],
            booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
            proficiency: formattedProficiencyLevel,
            area: selectedCenter?.name || bookingData.selectedCenter?.name || null,
            payment_id: null,
            amount: bookingData.amount
          };

          const createTrialResponse = await axios.post(
            'https://admin.machaxi.com/summer-api/trial/create-playing-trial2',
            createTrialPayload,
            {
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': process.env.REACT_APP_API_KEY,
              }
            }
          );

          console.log("DEBUG - createTrialResponse", createTrialResponse);
          const createTrialSuccess = createTrialResponse.status === 200 && (
            createTrialResponse.data?.success === true ||
            (typeof createTrialResponse.data?.message === 'string' && createTrialResponse.data.message.toLowerCase().includes('success'))
          );

          if (createTrialSuccess) {
            Swal.fire({
              icon: 'success',
              title: 'Booking Confirmed!',
              text: 'Your trial has been successfully booked.',
              confirmButtonColor: '#322978'
            }).then(() => {
              window.location.href = '/SuccessPage';
              sessionStorage.setItem('paymentStatus', 'success');
              sessionStorage.setItem('message', 'Your trial has been successfully booked.');
              onClose();
              setContactNumber('');
              setIsOtpVerified(false);
              setOtp('');
              setShowOtpInput(false);
            });
          } else {
            throw new Error(createTrialResponse.data?.message || 'Failed to confirm zero-amount booking.');
          }
          return;
        }

        // Validate Slots for non-zero amount
        const validateSlotsPayload = {
          parent_id: parentIdToSend,
          user_id: childIdToSend,
          name: bookingData.userName,
          mobile_number: formattedMobileNumber,
          source: 'Swimming_Playing',
          academy_id: academyIdToSend,
          court_id: selectedCourtId,
          sport_id: 11,
          // sport_id: 97,
          booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
          amount: bookingData.amount,
          payment_id: null,
          start_time: bookingData.selectedTrialTime.split(" - ")[0],
          end_time: bookingData.selectedTrialTime.split(" - ")[1],
          area: selectedCenter.name,
          proficiency: formattedProficiencyLevel
        }

        const validateResponse = await axios.post(process.env.REACT_APP_API_URL_VALIDATE_SLOTS,
          validateSlotsPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_API_KEY,
            }
          }
        );

        console.log("DEBUG - Slot validation response:", validateResponse);
        if (validateResponse?.data?.result?.isValid) {
          console.log("DEBUG - Slot validation successful:", validateResponse.data.message);
        } else {
          throw new Error(validateResponse.data.message || 'Selected slot is no longer available. Please choose a different slot.');
        }

        // Create Razorpay order
        const razorpayPayload = {
          amount: bookingData.amount * 100,
          currency: 'INR',
          receipt: `receipt_${Date.now()}`
        }

        const razorpayOrder = await axios.post(
          process.env.REACT_APP_API_URL_ORDER_ID,
          razorpayPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_API_KEY,
            }
          }
        );

        if (!razorpayOrder.data || !razorpayOrder.data.id) {
          throw new Error('Failed to create Razorpay order. Please try again.');
        }

        console.log("DEBUG - Razorpay Order Response:", razorpayOrder.data);
        const razorpayOrderId = razorpayOrder.data.id;

        const backendOrderPayload = {
          userId: parentIdToSend,
          orderDetails: [{
            academy: academyIdToSend,
            amount: bookingData.amount, // Amount in INR
            amountAfterDiscount: bookingData.amount, // Amount in INR
            discountAmount: 0,
            gstAmount: 0,
            payableAmount: bookingData.amount, // Amount in INR
            paymentId: null,
            regRenFees: null,
            regRenType: null,
            isCoaching: false,
            isRenewal: false,
            isTrial: true,
            rpOrderId: razorpayOrderId,
            source: "Swimming_Playing",
            proficiency: formattedProficiencyLevel
          }]
        }

        const backendOrderResponse = await axios.post(process.env.REACT_APP_API_URL_CREATE_ORDER,
          backendOrderPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': "jNtunfkUwiAT4YXgQacG84SXO0ZRrzCxSnyUaFunQqg",

            }
          }
        );

        if (!backendOrderResponse.data || !backendOrderResponse.data.data || !backendOrderResponse.data.data[0] || !backendOrderResponse.data.data[0].orderId) {
          throw new Error('Failed to create backend order. Please try again.');
        }

        const backendOrderId = backendOrderResponse.data.data?.[0].orderId;

        //Create Pre-Order details for Razorpay Webhook
        const preOrderPayload = {
          parent_id: parentIdToSend,
          user_id: childIdToSend ?? parentIdToSend, // Use child ID if available, otherwise use parent ID
          name: bookingData.userName,
          mobile_number: `+91${bookingData.contactNumber}`,
          gender_type: "Male",
          court_id: selectedCourtId,
          academy_id: academyIdToSend,
          sport_id: 11,
          // sport_id: 97,
          start_time: bookingData.selectedTrialTime.split(" - ")[0],
          end_time: bookingData.selectedTrialTime.split(" - ")[1],
          booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
          proficiency: formattedProficiencyLevel,
          area: selectedCenter.name,
          source: "Swimming_Playing",
          is_coaching: false,
          discount: 0,
          amount: bookingData.amount,
          final_payable_amount: bookingData.amount,
          coupon_code: null,
          order_id: backendOrderId,
          rz_order_id: razorpayOrderId,
        }

        console.log("DEBUG - preOrderPayload", preOrderPayload);

        const preOrderResponse = await axios.post(process.env.REACT_APP_API_URL_CREATE_PRE_ORDER,
          preOrderPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_API_KEY,
            }
          }
        );

        const razorpay = new window.Razorpay({
          key: process.env.REACT_APP_API_RAZORPAY_KEY,
          amount: razorpayOrder.data.amount,
          currency: razorpayOrder.data.currency,
          order_id: razorpayOrder.data.id,
          name: 'Machaxi Swimming Playing Trial',
          description: `Booking - ${userDetails.parent.name || userName}, MN:${bookingData.contactNumber}`,

          handler: async function (response) {
            console.log('Razorpay payment success response:', response);

            if (
              response.razorpay_payment_id &&
              response.razorpay_order_id &&
              response.razorpay_signature
            ) {
              console.log("DEBUG - Payment successful, verifying order status with backend...");
              const verificationPayload = {
                orderId: razorpayOrderId
              }
              try {
                const verifyResponse = await axios.post(process.env.REACT_APP_API_URL_VERIFY_ORDER_STATUS,
                  verificationPayload,
                  {
                    headers: {
                      'Content-Type': 'application/json',
                      'x-api-key': 'jNtunfkUwiAT4YXgQacG84SXO0ZRrzCxSnyUaFunQqg',
                    }
                  }
                );
                console.log("DEBUG - Verify Payment Response:", verifyResponse.data);
                if (verifyResponse.data.success) {
                  window.location.href = '/SuccessPage';
                  sessionStorage.setItem('paymentStatus', 'success');
                  sessionStorage.setItem('message', 'Your trial has been successfully booked.');
                  onClose();
                  setContactNumber('');
                  setIsOtpVerified(false);
                  setOtp('');
                  setShowOtpInput(false);
                } else {
                  throw new Error(verifyResponse.data.message || 'Payment verification failed');
                }
              } catch (err) {
                console.log('Error inside verifyPayment handler:', err);
                Swal.fire({
                  icon: 'error',
                  title: 'Payment Verification Failed',
                  text: err.message || 'Your payment was successful, but we could not verify it. Please contact support with your payment details.',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true
                });
              }
            }
          },

          modal: {
            ondismiss: function () {

              Swal.fire({
                icon: 'info',
                title: 'Payment Cancelled',
                text: 'If amount is deducted, please contact support.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
              });
            }
          },

          prefill: {
            name: userDetails?.parent?.name || userName,
            contact: bookingData.contactNumber,
          },

          theme: {
            color: '#322978'
          }
        });

        razorpay.on('payment.failed', function (err) {
          console.log('Razorpay payment.failed event:', err);

          Swal.fire({
            icon: 'error',
            title: 'Payment Failed',
            text: 'Please try again. If amount is deducted, contact support.',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000
          });
        });

        razorpay.open();
      } catch (error) {
        console.error('Error during confirmation:', error);

        let errorMessage = 'Failed to process the booking';

        // Check if error response exists and extract the message
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || JSON.stringify(error.response.data);
        } else if (error.message) {
          errorMessage = error.message;
        }

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
        });
      }
    };
    const formatDateToYYYYMMDD = (dateString) => {
      const [day, month, year] = dateString.split('-');

      const date = new Date(`${year}-${month}-${day}`);
      if (isNaN(date.getTime())) {
        console.error("Invalid date string:", dateString);
        return "Invalid Date";
      }

      const formattedYear = date.getFullYear();
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
      const formattedDay = String(date.getDate()).padStart(2, '0');

      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    };

    const [start, end] = bookingData.selectedTrialTime.split(' - ');

    return (
      <div className="confirmation-modal-overlay">
        <div className="modal-content">
          <button className="close-btn" onClick={onClose}>
            <span className="close-icon">&times;</span>
          </button>

          <h3 className="modal-title">Confirm Your Trial</h3>
          <div className="booking-summary">
            <p><strong>Name:</strong> {bookingData.userName}</p>
            <p><strong>Contact Number:</strong> {bookingData.contactNumber}</p>
            <p><strong>Center:</strong> {bookingData.selectedCenter?.name}</p>
            <p><strong>Trial Date:</strong> {bookingData.selectedTrialDate}</p>
            <p><strong>Time Slot:</strong> {formatTo12Hour(start)}-{formatTo12Hour(end)}</p>
            {bookingData.isReschedule && (
              <p className="reschedule-note">
                This is a rescheduled booking, so no payment is required.
              </p>
            )}
            <p className="booking-amount-row">
              <strong>Payable Amount:</strong> <span className="booking-amount">₹{bookingData.amount}</span>
            </p>
          </div>
          <p className="trial-note">
            {bookingData.amount === 0 ? 'No online payment is required. Your booking will be confirmed directly.' : '*This one-time fee will be adjusted against your swimming plan purchase'}
          </p>
          <div className="modal-actions">
            <button onClick={handleConfirm} className="btn-confirm">
              {bookingData.amount === 0 ? (bookingData.isReschedule ? 'Confirm Reschedule' : 'Confirm Booking') : `Pay ₹${bookingData.amount}`}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const showBackendError = (error) => {
    let errorMessage = 'Something went wrong. Please try again.';

    // Extract error message from backend response
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
    });
  };

  const handleDateChange = (date) => {
    setSelectedTrialDate(date);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
    }));
  };
  useEffect(() => {
    if (selectedTrialDate && selectedCenter) {
      fetchAvailableSlots();
    }
  }, [selectedTrialDate, selectedCenter]);

  const fetchAvailableSlots = async () => {
    try {
      if (!selectedCenter?.id) {
        throw new Error('Selected center not found.');
      }

      function formatDateToYYYYMMDD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`; // Use dashes
      }

      const formattedDate = formatDateToYYYYMMDD(selectedTrialDate);

      const payload = {
        venueId: selectedCenter.id,
        // venueId:84,
        // sportId: 11,
        sportId: 11,
        date: formattedDate,
        user_id: userDetails?.parent?.id || null,
        // date: "2025-03-30"
      };

      const response = await axios.post(
        process.env.REACT_APP_API_URL_SLOT_CHECK,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY,
          }
        }
      );

      if (response.data.message === 'Successfully sent to external API') {
        console.log("DEBUG - slot check response:", response.data);
        const courtSlots = response.data.externalResponse.courts || [];

        // Transform the data into the format expected by the UI
        const processedSlots = courtSlots.flatMap(court =>
          court.slots.map(slot => ({
            court_id: court.courtId,
            open_time: slot.startTime,
            close_time: slot.endTime,
            status: slot.available ? 'Available' : 'Booked',
            available: slot.available,
            ticketsAvailable: slot.ticketsAvailable || 0
          }))
        );

        setAvailableSlots(processedSlots);
        setSlotAmount(response.data.adultTrialAmount);
        const isReschedule = response.data?.is_reschedule;
        return { isReschedule };
      } else if (response.data.message === 'Rescheduling limit exceeded' && !response.data.success) {
        // Handle rescheduling limit exceeded
        setAvailableSlots([]);
        setSlotAmount(null);
        Swal.fire({
          icon: 'warning',
          title: 'Rescheduling Limit Exceeded',
          text: 'You have reached the maximum number of rescheduling attempts. Please contact support for assistance.',
          confirmButtonColor: '#322978'
        });
        return null;
      } else {
        throw new Error('Failed to fetch available slots.');
      }
    } catch (error) {
      console.error('Error fetching available slots:', error);
      const rescheduleLimitError = typeof (error?.response?.data?.message) === "string" && error?.response?.data?.message === "Rescheduling limit exceeded";
      if (rescheduleLimitError) {
        setAvailableSlots([]);
        setSlotAmount(null);
        Swal.fire({
          icon: 'warning',
          title: 'Rescheduling Limit Exceeded',
          text: 'You have reached the maximum number of rescheduling attempts. Please contact support for assistance.',
          confirmButtonColor: '#322978'
        });
        const isRescheduleLimitError = true;
        return {
          isRescheduleLimitError
        };
      }
      showBackendError(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to fetch available slots.',
      });
      return null;
    }
  };
  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}:${month}:${day}`;
  };

  const formatTo12Hour = (time) => {
    if (!time) return '';

    const [hour, minute] = time.split(':');
    let h = parseInt(hour, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';

    h = h % 12;
    h = h ? h : 12; // 0 becomes 12

    return `${h}:${minute} ${ampm}`;
  };

  useEffect(() => {
    setSelectedTrialTime(null); // ✅ Reset timeslot when date updates
  }, [selectedTrialDate]);

  const TermsModal = ({ show, onClose, data, onAgree }) => {
    if (!show) return null;

    return (
      <div className="terms-modal-overlay" onClick={onClose}>
        <div className="terms-modal-box" onClick={(e) => e.stopPropagation()}>
          <button className="terms-modal-close" onClick={onClose}>
            &times;
          </button>

          <h3 className="terms-modal-title">{data?.title || "Terms & Conditions"}</h3>

          <div className="terms-modal-body">
            {data?.sections?.length ? (
              data.sections.map((section, index) => (
                <div key={index} className="terms-section">
                  <h4>{section.heading}</h4>
                  <p>{section.content}</p>
                </div>
              ))
            ) : (
              <p>No terms available.</p>
            )}
          </div>
          <div className="terms-modal-footer">
            <button
              className="terms-agree-btn"
              onClick={() => {
                onAgree();
                onClose();
              }}
            >
              I Agree
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="book-trial-container">
      <h2 className="rescedule-title">
        Book Trial
      </h2>
      <form className="booking-form" onSubmit={handleSubmit}>
        <div className="location-search-section-trial">
          <label className="trial-time-label">Search Your Location</label>
          <div className="search-bar-wrapper">
            <Autocomplete
              apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
              className="location-search-input-booking"
              onPlaceSelected={handleLocationSearch}
              options={{
                types: ["geocode", "establishment"],
                componentRestrictions: { country: "in" },
              }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search area, street or building..."
            />

            <button
              type="button"
              className={`current-location-btn ${locationLoading ? 'loading' : ''}`}
              onClick={updateLocation}
            >
              <img src={locationIcon} alt="Loc" className="geo-icon" />
            </button>
          </div>
        </div>

        <div className="centers-list-container">
          <label className="trial-time-label">Select Centre:</label>

          {locationLoading ? (
            <div>
              <p>Fetching location...</p>
            </div>
          ) : (
            <div className="centers-details-row">
              {centers.map((center) => (
                <div
                  key={center.id}
                  className={`mini-center-card ${selectedCenter?.id === center.id ? 'active-card' : ''}`}
                  onClick={() => handleCenterSelect(center)}
                >
                  <div className="image-container-mini">
                    <img src={center.images?.[0]} alt={center.name} className="center-image-mini" />

                    {center.distance !== undefined && (
                      <div className="distance-badge-mini">
                        {center.distance.toFixed(1)} km away
                      </div>
                    )}
                  </div>

                  <div className="info-container-mini">
                    <div className="text-content">
                      <h3 className="center-name-mini">{center.name}</h3>
                      <p className="center-address-mini">{center.address}</p>

                      <a
                        href={center.mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="view-map-link-mini"
                        onClick={(e) => e.stopPropagation()}
                      >
                        View on Map
                      </a>
                    </div>

                    <button type="button" className="select-center-btn-mini">
                      {selectedCenter?.id === center.id ? 'SELECTED' : 'SELECT CENTRE'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {errorMessages.selectedCenter && <p className="error">{errorMessages.selectedCenter}</p>}
        </div>

        {selectedCenter && (
          <div><label className="form-date">Trial Date:</label></div>
        )}

        {selectedCenter && (
          <div className="floating-select">
            <DatePicker
              className={`sales-filter-academy ${selectedTrialDate ? 'has-value' : ''}`}
              selected={selectedTrialDate}
              onChange={handleDateChange}
              minDate={new Date()}
              excludeDates={excludedTrialDates}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select trial date"
              required
              inline
            />
            {errorMessages.selectedTrialDate && (
              <p className="error">{errorMessages.selectedTrialDate}</p>
            )}
          </div>
        )}

        {slotAmount !== null && (
          <div className="slot-amount-box">
            <span className="slot-amount-label">Trial Fee</span>
            <span className="slot-amount-value">₹{slotAmount}</span>
          </div>
        )}

        {selectedTrialDate && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Time Slot:</label>
            <div className="trial-time-options">
              {availableSlots.length > 0 ? (
                availableSlots.map((slot, index) => {
                  const startTime = slot.open_time ? slot.open_time.slice(0, 5) : 'N/A';
                  const endTime = slot.close_time ? slot.close_time.slice(0, 5) : 'N/A';
                  const isAvailable = slot.status === 'Available';

                  return (
                    <button
                      type='button'
                      key={index}
                      className={`trial-time-option ${selectedTrialTime === `${startTime} - ${endTime}` ? 'selected' : ''
                        } ${!isAvailable ? 'disabled' : ''}`}
                      onClick={() =>
                        handleTrialTimeChange(
                          `${startTime} - ${endTime}`,
                          null, // batchId - pass null if not used
                          slot.status,
                          slot.court_id,
                        )
                      }
                      disabled={!isAvailable}
                    >
                      <div>
                        {formatTo12Hour(startTime)} - {formatTo12Hour(endTime)}
                      </div>
                      <div>
                        {slot.status}
                      </div>
                    </button>
                  );
                })
              ) : (
                <p className="no-time-slot">No Time Slots Available</p>
              )}
            </div>
            {errorMessages.selectedTrialTime && (
              <p className="error">{errorMessages.selectedTrialTime}</p>
            )}
          </div>
        )}

        <div className="floating-select">
          <input
            className={`sales-filter-academy ${contactNumber ? 'has-value' : ''}`}
            type="tel"
            value={contactNumber}
            onChange={(e) => handleInputChange(e, 'contactNumber')}
            onKeyPress={(e) => {
              if (!/^[0-9]$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
            placeholder="Enter 10-digit phone number"
          />

          {contactNumber && <label htmlFor="contactNumber">Contact Number</label>}
          {errorMessages.contactNumber && <p className="error">{errorMessages.contactNumber}</p>}
          {errorMessages.otp && <p className="error">{errorMessages.otp}</p>}
          {isOtpVerified && (
            <span className="checkmark">✓</span>
          )}

          {!showOtpInput && !isOtpVerified && isContactNumberValid && (
            <button
              type="button"
              onClick={handleSendOtpClick}
              className="btn-send-otp"
              disabled={isOtpLoading || isOtpSent}
            >
              {isOtpLoading
                ? "Sending..."
                : isOtpSent
                  ? "OTP Sent"
                  : "Send OTP"}
            </button>
          )}
        </div>

        {showOtpInput && !isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${otp ? 'has-value' : ''}`}
              type="text"
              value={otp}
              onChange={(e) => handleInputChange(e, 'otp')}
              maxLength={6}
              placeholder="Enter OTP"
            />
            <button type="button" onClick={handleOtpVerification} className="btn-send-otp">
              Verify OTP
            </button>
          </div>
        )}

        {isNewUser && isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${userName ? 'has-value' : ''}`}
              type="text"
              value={userName}
              onChange={(e) => handleInputChange(e, 'userName')}
              placeholder="Enter your name"
            />
            {userName && <label htmlFor="userName">Name</label>}
            {errorMessages.userName && <p className="error">{errorMessages.userName}</p>}
          </div>
        )}

        {isOtpVerified && userDetails && (
          <div className="floating-select-child" ref={selectWrapperRef}>
            <label htmlFor="child" className="selectchild">User Name</label>

            <div
              className={`sales-filter-academy ${userName ? 'has-value' : ''}`}
              contentEditable
              suppressContentEditableWarning
              onBlur={(e) => {
                const newName = e.target.textContent;
                // Update both userDetails and userName state
                setUserDetails(prev => ({
                  ...prev,
                  parent: { ...prev.parent, name: newName }
                }));
                setUserName(newName); // 🔄 Update the userName state with edited value
              }}
            >
              {/* Display current userName instead of API name */}
              {userName || userDetails.parent.name}
            </div>

            {errorMessages.child && <p className="error">{errorMessages.child}</p>}
          </div>
        )}

        <div className="terms-checkbox-wrapper">
          <label className="terms-checkbox-label">
            <input
              type="checkbox"
              checked={isTermsAccepted}
              onChange={(e) => {
                setIsTermsAccepted(e.target.checked);
                setErrorMessages((prev) => ({ ...prev, termsAccepted: '' }));
              }}
            />
            <span>
              I agree to{" "}
              <button
                type="button"
                className="terms-link-btn"
                onClick={() => setShowTermsModal(true)}
              >
                Terms & Conditions
              </button>
            </span>
          </label>

          {errorMessages.termsAccepted && (
            <p className="error">{errorMessages.termsAccepted}</p>
          )}
        </div>

        <div className="form-group">
          <button className="form-button" type="submit">Proceed</button>
        </div>

        <ConfirmationModal
          showModal={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          selectedCourtTimingId={selectedCourtTimingId}
          selectedCourtId={selectedCourtId}
          onConfirm={() => {
            alert('Booking Confirmed!');
            setShowConfirmationModal(false);

          }}
          bookingData={formData}
        />

        <TermsModal
          show={showTermsModal}
          onClose={() => setShowTermsModal(false)}
          data={termsData}
          onAgree={() => {
            setIsTermsAccepted(true);
            setErrorMessages((prev) => ({ ...prev, termsAccepted: '' }));
          }}
        />
      </form>
    </div>
  );
};

export default BookTrial;
